// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dashboard-container[data-v-51add840] {\n  margin: 30px;\n}\n.dashboard-text[data-v-51add840] {\n  font-size: 30px;\n  line-height: 46px;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
